<div class="leaderboard-container">
  <div class="header">
    <div class="logo">
      <img src="assets/images/play-octopus-logo.png" alt="Octopus Logo">
      <div class="title">Leaderboard</div>
    </div>
  </div>

  <div class="container">
    <div class="page-header">
      <h3 class="text-center">Top 500 Drivers</h3>
      <div>
        @if (isLoadingDrivers) {
          <div class="points-updated">
            Points last updated -
            <mat-spinner diameter="18" mode="indeterminate"></mat-spinner>
            checking...
          </div>
        }
        @if (!isLoadingDrivers) {
          <div class="points-updated">
            Points last updated - {{ lastUpdatedTime ? (lastUpdatedTime | date:'medium') : '--' }}
          </div>
        }
      </div>
    </div>

    <div class="duration">
      <mat-nav-list>
        @for (duration of durations; track duration) {
          <a mat-list-item [class.active]="duration === selectedDuration"
            (click)="onDurationChange(duration)">
            {{ duration }}
          </a>
        }
      </mat-nav-list>
    </div>


    @if (dataSource?.data?.length > 0) {
      <div class="search-bar">
        <label for="leaderboard-search" class="sr-only">Search drivers by first name, market, or rank</label>
        <input type="text" id="leaderboard-search" placeholder="Search with your first name or market or rank" [(ngModel)]="searchTerm"
          (input)="filterDrivers()" />
      </div>
    }

    <div class="leaderboard">

      @if (isLoadingDrivers) {
        <div class="loading-container">
          <mat-spinner [diameter]="24"></mat-spinner>
          &nbsp;Fetching Leaderboard...
        </div>
      }

      @if (!isLoadingDrivers && dataSource?.data?.length === 0) {
        <div class="no-data">
          No drivers found for the selected duration.
        </div>
      }

      @if (!isLoadingDrivers && dataSource?.data?.length > 0) {
        <table mat-table [dataSource]="dataSource"
          #leaderboard>
          <ng-container matColumnDef="rank">
            <th mat-header-cell *matHeaderCellDef>Rank</th>
            <td mat-cell *matCellDef="let driver" class="rank">{{ driver.rank }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let driver" class="name-container">
              <div class="name">{{ driver.name }}</div>
              <div class="market">{{ driver.market_name }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="points">
            <th mat-header-cell *matHeaderCellDef>Points</th>
            <td mat-cell *matCellDef="let driver" class="points">
              {{ driver.points | number: '1.0-1' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true; scrollable: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }

    </div>

  </div>
</div>